import * as React from "react";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { DetailRouteProps } from "./routes-path";
import DetailPrestupu, { DetailPrestupuProps } from "common/components/evidence/clenove/prestupy/DetailPrestupu";
import PageContent from "common/web/PageContent";

interface PrestupyDetailProps {
    clenId: number;
}

type Props = PrestupyDetailProps & RouteComponentProps<DetailRouteProps>;

class PrestupyDetail extends React.PureComponent<Props> {

    render() {
        const { clenId } = this.props;
        const { prestupId } = this.props.match.params;

        const dpProps: DetailPrestupuProps = {
            prestupId: Number(prestupId),
            clenId: clenId,
        }
        return <PageContent titles={['Přestupy', 'Detail přestupu']}>
            <DetailPrestupu {...dpProps} />
        </PageContent>
    }
}

export default withRouter(PrestupyDetail);